
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/campaign/jp/it-certification",
      function () {
        return require("private-next-pages/campaign/jp/it-certification.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/campaign/jp/it-certification"])
      });
    }
  